import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["content", "results", "typesCloud", "input"];

    static values = {
        currentFilter: Object,
    };

    initialize() {
        this.isLoading = false;
        this.isLoadMore = false;
    }

    connect() {}

    async updateResults(e) {
        const trigger = e.target.closest(
            '[data-generator-filter-target="input"]',
        );

        // Return when active filter item
        if (trigger.dataset.tagHandle == "generatorPackage") {
            if (trigger.dataset.tagId == this.currentFilterValue.package) {
                return;
            }
        } else {
            if (
                e.target
                    .closest("li[role='option']")
                    .getAttribute("aria-selected") == "true"
            ) {
                return;
            }
        }

        try {
            const optionData = this.getOptionData(trigger);
            this.updateCurrentFilterValues(
                optionData.tagHandle,
                optionData.tagId,
                optionData.defaultTypeId,
            );
            this.isLoading = true;
            if (this.currentFilterValue.filteredHandle == "templateGroup") {
                this.handleActiveStateFilterCloud();
            }
            // tagHandle == generatorPackages -> update selectCloud, results and info
            // tagHandle == presetType -> update results
            const container =
                optionData.tagHandle == "generatorPackage"
                    ? this.contentTarget
                    : this.resultsTarget;
            this.handleLoadingSpinner(container, this.isLoading);

            // Handle Url Params
            this.updateMultipleUrlParams({
                packageId: this.currentFilterValue.package,
                typeId: this.currentFilterValue.type,
            });

            // Fetch from URL and handle Results
            const response = await fetch(
                this.getFetchUrl(optionData.tagHandle, optionData.tagId),
            );
            const data = await response.text();
            this.clearResultsContainer(container);
            this.populateResultsContainer(container, data);

            this.isLoading = false;
            this.handleLoadingSpinner(container, this.isLoading);
        } catch (error) {
            console.log("There was an error", error);
        }
    }

    // Handle Results Container
    clearResultsContainer(container) {
        container.innerHTML = "";
    }
    populateResultsContainer(container, html) {
        container.insertAdjacentHTML("beforeend", html);
    }

    getFetchUrl(tagHandle, tagId) {
        let url = `/ajax/generator-packages?filteredHandle=${this.currentFilterValue.filteredHandle}&packageId=${this.currentFilterValue.package}&typeId=${this.currentFilterValue.type}`;
        return url;
    }

    // get filter option data of trigger
    getOptionData(element) {
        const { tagHandle, tagId, defaultTypeId } = element.dataset;
        return { tagHandle, tagId, defaultTypeId };
    }

    updateCurrentFilterValues(tagHandle, tagId, defaultTypeId) {
        // Set default type when switching package
        this.currentFilterValue = {
            ...this.currentFilterValue,
            filteredHandle: tagHandle,
        };
        if (tagHandle == "generatorPackage") {
            this.currentFilterValue = {
                ...this.currentFilterValue,
                package: tagId,
                type: defaultTypeId,
            };
        } else if (tagHandle == "templateGroup") {
            this.currentFilterValue = {
                ...this.currentFilterValue,
                type: tagId,
            };
        }
    }

    // Push Url Params
    updateMultipleUrlParams(params) {
        const url = new URL(window.location);

        // Add or update each parameter
        for (const [key, value] of Object.entries(params)) {
            url.searchParams.set(key, value);
        }

        // Update the browser URL
        history.pushState(null, "", url);
    }

    // Handle Loading Spinner
    createLoadingSpinner() {
        const loadBarOne = document.createElement("div");
        loadBarOne.classList.add(
            "bg-red-linke",
            "h-full",
            "w-[110%]",
            "absolute",
            "top-[0.25em]",
            "left-0",
            "animate-loadBarOne",
        );
        const loadBarTwo = document.createElement("div");
        loadBarTwo.classList.add(
            "bg-red-dark",
            "h-full",
            "w-[110%]",
            "absolute",
            "top-[0.25em]",
            "left-0",
            "animate-loadBarTwo",
        );
        const loadBarThree = document.createElement("div");
        loadBarThree.classList.add(
            "bg-red-linke",
            "h-full",
            "w-[110%]",
            "absolute",
            "top-[0.25em]",
            "left-0",
            "animate-loadBarThree",
        );
        const innerContainer = document.createElement("div");
        innerContainer.classList.add(
            "relative",
            "h-full",
            "w-full",
            "-skew-y-[8deg]",
            "overflow-y-visible",
            "overflow-x-clip",
        );
        const outerContainer = document.createElement("div");
        outerContainer.classList.add(
            "absolute",
            "h-full",
            "w-full",
            "top-1/2",
            "left-1/2",
        );

        innerContainer.appendChild(loadBarOne);
        innerContainer.appendChild(loadBarTwo);
        innerContainer.appendChild(loadBarThree);

        const srText = document.createElement("span");
        srText.innerText = "Loading...";
        srText.classList.add("sr-only");

        outerContainer.appendChild(innerContainer);

        const loadBar = document.createElement("div");
        loadBar.classList.add("sticky", "top-4", "w-[2.5em]", "h-[1em]");
        loadBar.setAttribute("role", "status");

        loadBar.appendChild(outerContainer);
        loadBar.appendChild(srText);

        return loadBar;
    }
    handleLoadingSpinner(targetSection, isLoading) {
        if (isLoading) {
            targetSection.classList.add("relative");
            const overlay = document.createElement("div");
            overlay.classList.add(
                "bg-offwhite",
                "absolute",
                "top-0",
                "left-0",
                "w-full",
                "h-full",
                "bg-opacity-50",
                "flex",
                "items-start",
                "justify-center",
            );
            overlay.style.zIndex = "40";
            overlay.id = "loadingOverlay";
            const loadingSpinner = this.createLoadingSpinner();
            overlay.appendChild(loadingSpinner);
            targetSection.appendChild(overlay);
        } else {
            document.getElementById("loadingOverlay") &&
                document.getElementById("loadingOverlay").remove();
        }
    }

    handleActiveStateFilterCloud() {
        const options =
            this.typesCloudTarget.querySelectorAll("li[role='option']");
        options.forEach((option) => {
            if (
                this.currentFilterValue.type == option.children[0].dataset.tagId
            ) {
                option.setAttribute("aria-selected", true);
            } else {
                option.setAttribute("aria-selected", false);
            }
        });
    }
}
